@if (races.length) {
    <section class="horses-meeting-all">
        <div class="content-wrapper">
            <ul>
                @for (race of races; track $index) {
                    <li (click)="onFixtureClick(race.fixture)">
                        <a [href]="race.fixtureUrl">
                            <div class="race-item ms-active-highlight">
                                @if (race.pricingState === pricingStates.None) {
                                    <span class="race-badge"></span>
                                }
                                @if (race.pricingState === pricingStates.Resulted) {
                                    <span class="race-badge">
                                        <vn-icon class="sports-race-resulted-icon" name="sports-race-resulted" width="11" height="16"></vn-icon>
                                    </span>
                                }
                                @if (race.pricingState === pricingStates.Priced) {
                                    <span class="race-badge priced">P</span>
                                }
                                @if (race.pricingState === pricingStates.RaceOff) {
                                    <span class="race-badge started">O</span>
                                }
                                <span class="race-time">{{ race.startDate | date: 'shortTime' }}</span>
                                <span class="race-title">{{ race.raceName }}</span>
                                <div class="badges-wrapper">
                                    <ms-race-view-best-odds-badge [fixture]="race.fixture"></ms-race-view-best-odds-badge>
                                </div>
                            </div>
                            <vn-icon name="theme-right" size="16" class="link-arrow right-icon"></vn-icon>
                        </a>
                    </li>
                }
            </ul>
        </div>
    </section>
} @else {
    <ms-error severity="info" [message]="sitecore.event.ErrNoEventsPerFilter"></ms-error>
}
